// src/store/modules/user.js
import { setToken, removeToken, setUserInfo } from '@/utils/auth'
import { login, logout } from '@/api/auth'
import { getUserInfo } from '@/api/user'
import { clearApiCache } from '@/utils/apiCache'
import { clearAppStorage } from '@/utils/migrateLegacyStorage'

export default {
    namespaced: true,
    state: {
        token: '',
        userInfo: null
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER_INFO(state, info) {
            state.userInfo = info
        }
    },
    actions: {
        // 修复 - 使用传入的loginForm参数而不是外部userInfo
        async login({ commit }, loginData) {
            const response = await login(loginData)
            clearApiCache()
            setToken(response.data.access)
            commit('SET_TOKEN', response.data.access)
            return response
        },
        async getUserInfo({ commit }) {
            try {
                const response = await getUserInfo()
                setUserInfo(response.data)
                commit('SET_USER_INFO', response.data)
                return response
            } catch (error) {
                console.error('获取用户信息失败:', error)
                // 确保这里的错误处理不会导致无限循环
                if (error.response.status === 401) {
                    commit('SET_TOKEN', '')
                    commit('SET_USER_INFO', null)
                    removeToken()
                }
                return Promise.reject(error)
            }
        },
        // 退出登录
        logout({ commit }) {
            logout()
            return new Promise((resolve) => {
                clearApiCache()
                commit('SET_TOKEN', '')
                commit('SET_USER_INFO', null)
                removeToken()
                // 只清本项目命名空间，避免同域其它项目被误清
                clearAppStorage()
                resolve()
            })
        }

    }
}